enum QualityFormPermission {
    QUALITY_EVAL_FORM_ADD = "quality:evaluationForm:add",
    QUALITY_EVAL_FORM_AI_SCORING_EDIT = "quality:evaluationForm:aiScoringEdit",
    QUALITY_SURV_FORM_ADD = "quality:surveyForm:add",
    QUALITY_EVAL_EDIT = "quality:evaluation:edit",
    QUALITY_EVAL_VIEW = "quality:evaluation:view",
    QUALITY_EVAL_SEARCH_ANY = "quality:evaluation:searchAny",
    LEARNING_MODULE_ADD = "learning:module:add",
    LEARNING_MODULE_VIEW = "learning:assignment:view",
    QUALITY_CALIBRATION_ADD = "quality:calibration:add",
    STA_TOPIC_VIEW = "speechAndTextAnalytics:topic:view",
    STA_TRANSCRIPT_VIEW = "speechAndTextAnalytics:data:view",
    RECORDING_VIEW = "recording:recording:view",
    RECORDING_SEGMENT_VIEW = "recording:recordingSegment:view",
    QUALITY_EVAL_VIEW_SENSITIVE_DATA = "quality:evaluation:viewSensitiveData",
    QUALITY_SCORING_RULE_VIEW = "quality:scoringRule:view",
    QUALITY_SCORING_RULE_ADD = "quality:scoringRule:add",
    QUALITY_SCORING_RULE_EDIT = "quality:scoringRule:edit",
    QUALITY_SCORING_RULE_DELETE = "quality:scoringRule:delete",
}

export default QualityFormPermission;
